import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ClientApiService } from './client.service';
import { loadClientList, loadClientListSuccess, loadClientListFailure } from './client.actions';

@Injectable()
export class ClientEffects {
  private actions$ = inject(Actions);
  private clientService = inject(ClientApiService);

  loadClientList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadClientList),
      mergeMap(() =>
        this.clientService.getClientList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadClientListFailure({ error: response.message });
            }
            return loadClientListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadClientListFailure({ error })))
        )
      )
    )
  );
}
